import { connect } from 'react-redux';
import Preferences from './Preferences';
import { bindActionCreators } from 'redux';
import ThemeAction from '../../../modules/actions/ThemeAction';
import LayoutAction from '../../../modules/actions/LayoutAction';

const mapStateToProps = (state) => {
  return {
    selectedTheme: state.ThemeReducer.selectedTheme,
    selectedThemeing: state.ThemeReducer.selectedTheme
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ThemeAction: bindActionCreators(ThemeAction, dispatch),
    layoutAction: bindActionCreators(LayoutAction, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Preferences);
